module.exports = __webpack_public_path__ + "assets/images/key/key_kl_2020.svg?v=b399795d";